module.exports = __webpack_public_path__ + "img/news-nav-icon-5.a0942440.png";